/**
 * Single-email validation shared by the composer's To field and the CC chips,
 * so both apply the same rule (a bare `includes('@')` accepts `a@`, `@x`, `a@b`).
 */
export const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const isValidEmail = (value: string): boolean => EMAIL_RE.test(value.trim());
